import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export const OfferReadOnlyButton = (props) => {
    const { offerId, ...buttonProps } = props;
    const { t } = useTranslation();

    const handleClick = () => {
        if (!offerId) {
            return;
        }
        window.open(`/offers/preview/${offerId}`, "_blank", "noopener,noreferrer");
    };

    return (
        <Button variant="outlined" onClick={handleClick} disabled={!offerId} {...buttonProps}>
            {t("bookings.BookingManageDialog.previewOffer")}
        </Button>
    );
};
